(() => {
  const q = (selector, root = document) => root.querySelector(selector);
  const qa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function init(mega) {
    if (!mega || mega.dataset.w88Ready === '1') return;
    mega.dataset.w88Ready = '1';

    const header = mega.closest('.w80-header');
    if (!header) return;

    const links = qa('.w80-nav a', header);
    const trigger = q('.w80-nav__all', header) || links.find((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      return text.includes('alle categorie') || text === 'assortiment' || text === 'alle producten';
    });
    if (!trigger) return;

    let timer = 0;
    const tabs = qa('[data-w88-tab]', mega);
    const panels = qa('[data-w88-panel]', mega);
    const desktop = () => matchMedia('(min-width:1001px)').matches;

    trigger.dataset.w88Trigger = '1';
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-controls', mega.id || 'W88CatalogMega');
    trigger.setAttribute('aria-expanded', 'false');

    const clear = () => {
      if (!timer) return;
      clearTimeout(timer);
      timer = 0;
    };

    const open = () => {
      if (!desktop()) return;
      clear();
      mega.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      clear();
      mega.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    const later = () => {
      clear();
      timer = setTimeout(close, 180);
    };

    const activate = (key, { focus = false } = {}) => {
      tabs.forEach((button) => {
        const active = button.dataset.w88Tab === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.tabIndex = active ? 0 : -1;
        if (active && focus) button.focus();
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.w88Panel !== key;
      });
    };

    const moveTab = (current, direction) => {
      const index = Math.max(0, tabs.indexOf(current));
      let nextIndex = index;
      if (direction === 'next') nextIndex = (index + 1) % tabs.length;
      if (direction === 'prev') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (direction === 'first') nextIndex = 0;
      if (direction === 'last') nextIndex = tabs.length - 1;
      const next = tabs[nextIndex];
      if (next) activate(next.dataset.w88Tab, { focus: true });
    };

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('click', (event) => {
      if (desktop() && mega.hidden) {
        event.preventDefault();
        open();
      }
    });

    const nav = trigger.closest('.w80-nav');
    if (nav) {
      nav.addEventListener('mouseenter', clear);
      nav.addEventListener('mouseleave', later);
    }
    mega.addEventListener('mouseenter', clear);
    mega.addEventListener('mouseleave', later);

    tabs.forEach((button) => {
      const run = () => activate(button.dataset.w88Tab);
      button.addEventListener('mouseenter', run);
      button.addEventListener('focus', run);
      button.addEventListener('click', run);
      button.addEventListener('keydown', (event) => {
        let direction = '';
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') direction = 'next';
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') direction = 'prev';
        if (event.key === 'Home') direction = 'first';
        if (event.key === 'End') direction = 'last';
        if (!direction) return;
        event.preventDefault();
        moveTab(button, direction);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !mega.hidden) {
        close();
        trigger.focus();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!mega.hidden && !mega.contains(event.target) && event.target !== trigger && !trigger.contains(event.target)) close();
    });

    addEventListener('resize', () => {
      if (!desktop()) close();
    }, { passive: true });
  }

  const boot = () => qa('[data-w88-mega]').forEach(init);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot, { once: true })
    : boot();
})();
